import PropTypes from 'prop-types';
import React from 'react';
import {button} from 'src/styles/modules/button.module.scss';
import DeflectionCall from 'src/svgs/scheduleCallback/DeflectionCall.svg';
import {DeflectionMovingBox} from 'src/svgs/scheduleCallback/DeflectionMovingBox';
import {header} from '../header.module.scss';
import {
  icons,
  interstitialHeader,
  interstitialButton,
  interstitialCard,
  suggestionText,
} from '../interstitial.module.scss';

export const MovingInterstitialView = ({
  movingUrl,
  onGetCall,
  onMoving,
}) => (
  <>
    <header className={header}>
      <h1>We can help with that</h1>
      <p>We found some common solutions to try first, or you can schedule a call below.</p>
    </header>

    <div className={interstitialCard}>
      <div className={interstitialHeader}>
        <DeflectionMovingBox className={icons} />
        <p>Are you moving soon?</p>
        <a className={`${button} ${interstitialButton}`} href={movingUrl} onClick={onMoving}>Get Started</a>
      </div>
      <hr />
      <div className={suggestionText}>
        <p>We can easily transfer your service to your new home in a few simple steps.</p>
      </div>
    </div>

    <div className={interstitialCard}>
      <div className={interstitialHeader}>
        <DeflectionCall className={icons} />
        <p>I&apos;d like to speak with an agent</p>
        <button className={`${button} ${interstitialButton}`} onClick={onGetCall}>Get a Call</button>
      </div>
    </div>
  </>
);

MovingInterstitialView.propTypes = {
  movingUrl: PropTypes.string.isRequired,
  onGetCall: PropTypes.func.isRequired,
  onMoving: PropTypes.func.isRequired,
};
